import { useSelectorEq } from "commons/store/common";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { type IState } from "store/modules";
import type { ProfitTabType } from "./ProfitVo";
import {
  apiGProfitChartData,
  apiGpaymentGridData,
  apiGprofitDetailList,
  apiGprofitDownloadExcel,
  rdxResetAllData,
  rdxResetProfitChartData,
} from "./ProfitR";
import { useApi } from "store/modules/common";
import { useChannelListLoad } from "pages/statistics/store/StatisticsHook";

export const useInitPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      // dispatch(rdxResetAllData());
    };
  }, []);
};

export const useOptionListInit = () => {
  const { tab, optionList } = useSelectorEq((state: IState) => ({
    tab: state.profit.activeTab,
    optionList: state.statistics.channelList,
  }));

  const channelListLoad = useChannelListLoad();

  useEffect(() => {
    channelListLoad(tab);
  }, [tab]);

  return { tab, optionList };
};

export const useProfitChartListLoad = () => {
  const { apiResult } = useApi();

  return async (type: ProfitTabType) => {
    await apiResult(apiGProfitChartData);
  };
};

export const useProfitGridListLoad = () => {
  const { apiResult } = useApi();

  return async (type?: ProfitTabType) => {
    // await apiResult(apiGprofitGridData, { page: page });
    await apiResult(apiGprofitDetailList, type);
  };
};

export const usePaymentGridListLoad = () => {
  const { apiResult } = useApi();

  return async (type?: ProfitTabType, num?: number) => {
    const page = num ? num : 0;
    await apiResult(apiGpaymentGridData, { page: page });
  };
};

/**
 * 통계 차트 관련
 * @returns
 */
export const useProfitChart = () => {
  const { isLoading, tab, chart, year, selectChannel } = useSelectorEq((state: IState) => ({
    isLoading: state.profit.isLoading.chart,
    tab: state.profit.activeTab,
    chart: state.profit.chart,
    year: state.ui.selectbox?.["profit_year_date"],
    selectChannel: state.navigates.selectChannel,
  }));
  const chartList = useProfitChartListLoad();

  const dispatch = useDispatch();

  useEffect(() => {
    if (year && tab) {
      chartList(tab);
    }
  }, [year, tab, selectChannel]);

  useEffect(() => {
    return () => {
      dispatch(rdxResetProfitChartData());
    };
  }, []);

  return { isLoading, tab, chart };
};

export const useProfitGridLoad = (tab: string) => {
  const { isLoading, profitInfo, year, month, selectChannel } = useSelectorEq((state: IState) => ({
    isLoading: state.profit.isLoading.profit_list,
    profitInfo: state.profit.profitInfo,
    year: state.ui.selectbox?.["profit_detail_year"],
    month: state.ui.selectbox?.["profit_detail_month"],
    selectChannel: state.navigates.selectChannel,
  }));
  const gridListLoad = useProfitGridListLoad();

  const dispatch = useDispatch();

  useEffect(() => {
    if (year && month !== undefined) {
      gridListLoad(tab as ProfitTabType);
    }
  }, [year, month, tab, selectChannel]);

  useEffect(() => {
    return () => {
      dispatch(rdxResetAllData());
    };
  }, []);

  return { isLoading, profitInfo };
};

export const useDownloadPDF = () => {
  const url = "http://cdn-cp.viewus.co.kr/common/businessRegistration.pdf";
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("target", "_blank"); // 새 창 또는 탭에서 열도록 설정
  link.setAttribute("download", "FASTVIEW_사업자등록증.pdf");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const useCompanyExcelDownload = () => {
  const { apiResult } = useApi();
  const download = async (date: string) => {
    await apiResult(apiGprofitDownloadExcel, date);
  };
  return { download };
};

export const useProfitDate = () => {
  const { year, month } = useSelectorEq((state: IState) => ({
    year: state.profit.profitDate?.year,
    month: state.profit.profitDate?.month,
  }));
  return { year, month };
};
